import { render, staticRenderFns } from "./friendlyLink.vue?vue&type=template&id=3d77b69e&scoped=true&"
import script from "./friendlyLink.vue?vue&type=script&lang=js&"
export * from "./friendlyLink.vue?vue&type=script&lang=js&"
import style0 from "./friendlyLink.vue?vue&type=style&index=0&id=3d77b69e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77b69e",
  null
  
)

export default component.exports